<template>
  <div class="view pa24">
    <div class="d-flex">
      <div>
        <!-- <el-button class="mr10" type="primary">添加分类</el-button> -->
        <el-input class="w220 mr10" v-model="keyWord" :placeholder="$t('article', 'articleTitle')" />
        <el-date-picker
          v-model="pickerValue"
          class="mr10"
          align="right"
          value-format="yyyy-MM-dd"
          type="daterange"
          :start-placeholder="$t('marketing', 'startDate')"
          :end-placeholder="$t('marketing', 'endDate')"
          :picker-options="pickerOptions"
        />
        <el-button type="primary" @click="fnQueryClick">{{ $t('marketing', 'search') }}</el-button>
      </div>
      <div style="margin-left: auto">
        <el-button type="primary" @click="$router.push('/isDrafts')">{{ $t('article', 'isDrafts') }}</el-button>
        <el-button class="ml10" type="primary" @click="centerDialogVisible = true"
          >{{ $t('article', 'addActivity') }}</el-button
        >
      </div>
    </div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column type="index" align="center" :label="$t('common', 'serialNumber')" />
        <el-table-column prop="title" align="center" show-overflow-tooltip :label="$t('article', 'articleTitle')" />
        <el-table-column prop="originAuthor" align="center" :label="$t('article', 'author')">
          <template slot-scope="scope">
            {{ scope.row.originAuthor ? scope.row.originAuthor : "——" }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :label="$t('article', 'publishDate')">
          <template slot-scope="scope">
            {{ setDataTimeSec(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="shareNum" align="center" :label="$t('article', 'shareCount')" />
        <el-table-column prop="readNum" align="center" :label="$t('article', 'readCount')" />
        <el-table-column prop="readTime" align="center" :label="$t('article', 'readTime')" />
        <el-table-column prop="nickeName" align="center" :label="$t('article', 'author')" />
        <el-table-column prop="isDrafts" align="center" :label="$t('article', 'articleStatus')">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isDrafts == 1 ? false : true"
              @change="(e) => switchChange(e, scope.row.dynamicId)"
              :active-text="$t('article', 'publish')"
              :inactive-text="$t('article', 'close')"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="isTop" align="center" :label="$t('article', 'isTop')">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isTop == 1 ? true : false"
              @change="(e) => switchChange(e, scope.row.dynamicId,'stick')"
              :active-text="$t('common', 'yes')"
              :inactive-text="$t('common', 'no')"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('common', 'edit')" width="150">
          <template slot-scope="scope">
            <el-button class="mr10" type="text" @click="edit(scope.row)">{{ $t('common', 'edit') }}</el-button>
            <customPopconfirm
              :confirm-button-text="$t('common', 'confirm')"
              :cancel-button-text="$t('common', 'cancel')"
              @confirm='del(scope.row.dynamicId)'
              icon="el-icon-info"
              icon-color="red"
              :title="$t('common', 'confirm') + $t('article', 'confirmDeleteArticle')">
              <el-button slot="reference" style="color: #fd634e" type="text" >{{ $t('common', 'delete') }}</el-button>
            </customPopconfirm>
            
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      :title="$t('article', 'addActivity')"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="50%"
      center
    >
      <postArticles @submitForm="submitForm" ref="postArticles" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{ $t('common', 'cancel') }}</el-button>
        <el-button type="primary" @click="determine()">{{ $t('common', 'confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import postArticles from "./components/postArticles";
import customPopconfirm from "@/components/common/customPopconfirm";
import {
  getDynamicInfo,
  updateDynamicState,
  addDynamicInfo,
  delDynamicInfo,
  updateDynamicTop
} from "@/api/articleManagement";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "customerArticles",
  mixins: [i18nMixin],
  components: {
    commonTable,
    postArticles,
    customPopconfirm
  },
  data() {
    return {
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      keyWord: "", //文章标题
      pickerValue: "", //选择时间
      centerDialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableData: [],
    };
  },
  created() {
    this.getDynamicInfoAsync();
  },
  computed: {
    setDataTimeSec() {
      return (data) => getDataTimeSec(data);
    },
  },
  methods: {
    /**@method 获取文章管理 */
    async getDynamicInfoAsync(payload) {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        isDrafts:0,
        ...payload,
      };
      try {
        this.loading = true;
        const result = await getDynamicInfo(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        this.tableData = [];
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDynamicInfoAsync();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDynamicInfoAsync();
    },
    /**@method 切换文章发布状态
     * @param {Boolean} e - switch值
     * @param {String} id - id
     */
    async switchChange(e, id, type) {
      let data = {
        dynamicId: id,
        isDrafts: e ? 0 : 1,
      };
      if(type){
        data = {
          dynamicId: id,
          isTop: e ? 1 : 0,
        }
        updateDynamicTop(data)
        .then(res=>{
          if(e){
            this.$message.success(this.$t('article', 'topSuccess'))
          }else{
            this.$message.success(this.$t('article', 'cancelTopSuccess'))
          }
          this.getDynamicInfoAsync();
        })
        .catch(err=>{
          if(err.code == 201){
            console.log(err)
            this.$message.error(err.message)
          }
        })
      }else{
        await updateDynamicState(data);
        await this.getDynamicInfoAsync();
      }
      
      
      
    },
    /**@method 查询 */
    fnQueryClick() {
      this.currentPage = 1;
      let data = {
        startTime: this.pickerValue ? `${this.pickerValue[0]} 00:00:00` : "",
        endTime: this.pickerValue ? `${this.pickerValue[1]} 23:59:59` : "",
        title: this.keyWord,
      };
      this.getDynamicInfoAsync(data);
    },
    determine(data) {
      this.$refs.postArticles.submitForm(data);
    },
    /**
     * @method 发布文章提交
     * @param {Object} val - 表单值
     */
    async submitForm(val) {
      let data = {
        isDrafts: val.isDrafts ? 0 : 1,
        type:1,
        ...val,
      };
      try {
        await addDynamicInfo(data, { showLoading: true });
        this.centerDialogVisible = false;
        await this.getDynamicInfoAsync();
      } catch (error) {
        console.log(error);
        this.$message.error(error.message)
      }
    },
    /**@method 编辑
     * @param {Object} val - 当前点击行的值
     */
    edit(val) {
      this.centerDialogVisible = true;
      const {
        dynamicId,
        companyId,
        title,
        photos,
        details,
        originAuthor,
        createUserId,
        createTime,
        isDel,
        isTop,
        isDrafts,
      } = val;
      let data = {
        dynamicId,
        companyId,
        title,
        photos,
        details,
        originAuthor,
        createUserId,
        createTime,
        isDel,
        isTop:isTop ? true : false,
        isDrafts:isDrafts ? true : false,
      }
      console.log(val)
      console.log(data)
     this.$nextTick(() => {
        this.$refs.postArticles.ruleForm = data;
        this.$refs.postArticles.fileList.push({name:'',url:photos})
     })
    },
    /**@method 删除 
     * @param {String} val - 文章id
    */
    async del(val){
      try {
        await delDynamicInfo({dynamicId:val});
        await this.getDynamicInfoAsync();
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>